import { useEnvVariables, useUser } from '@innovamat/ga-features';
import { useQuery } from '@tanstack/react-query';

function usePrintingToolAuthorization(): {
  shouldRedirect: boolean;
  isLoading: boolean;
} {
  const { user } = useUser();
  const { MAKE_PRINTING_TOOL_URL } = useEnvVariables();

  const email = user?.email;

  const { data, isLoading, isError } = useQuery({
    queryKey: ['printing-tool-authorization', email],
    queryFn: async () => {
      const response = await fetch(`${MAKE_PRINTING_TOOL_URL}?e=${email}`);
      const data = await response.text();
      return data;
    },
    enabled: !!email,
    retry: false,
  });

  const isLoadingQuery = !email || isLoading;
  const shouldRedirect = !isLoadingQuery && (isError || email !== data);

  return {
    shouldRedirect,
    isLoading: isLoadingQuery,
  };
}

export { usePrintingToolAuthorization };
